import { Store, StoreType } from '@extTypes/dto/user';

export const isWooCommerceStore = (shop: string, stores: Store[]) => {
    const store = stores.find((s) => {
        return s.Url === shop;
    });
    return store && store.Type === StoreType.WooCommerce;
};

export const hasWooCommerceStores = (stores: Store[]) => {
    const store = stores.filter((s) => {
        return s.Type === StoreType.WooCommerce;
    });
    return !!store.length;
};
